import { render, staticRenderFns } from "./Quantidade.vue?vue&type=template&id=4603c414&scoped=true"
import script from "./Quantidade.vue?vue&type=script&lang=js"
export * from "./Quantidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4603c414",
  null
  
)

export default component.exports